(async () => {

  if (!customElements.get('product-media-slider')) {

    const { Fancybox } = await import("@fancyapps/ui");
    class ProductMediaSlider extends SliderComponent {
      constructor() {
        super();

        this.fancybox();

        // Listen for variant change and go to slide
        document.addEventListener('variant-change', this.slideToVariant.bind(this));

        // Go to initial slide on load
        let initialSlide = 0;
        const initialVariant = parseInt(this.dataset.productMediaSlider);
        if (initialVariant) {
          initialSlide = this.matchVariantIdWithSlide(initialVariant);
        }
        if (typeof initialSlide == 'number') {
          this.goToSlide(initialSlide, false);
        }
      }


      /*
      * Slide to variant
      * @Param e {object}: event object with variant
      */
      slideToVariant(event) {
        if (event?.detail?.variant?.id) {
          const slideIndex = this.matchVariantIdWithSlide(event.detail.variant.id);
          if (typeof slideIndex == 'number') {
            this.goToSlide(slideIndex, true);
          }
        }
      }


      /*
      * Match variant id with slide
      * @param id {int}: variant id
      */
      matchVariantIdWithSlide(id) {
        if (!id) {
          return false;
        }

        // Get slides
        const slides = this.querySelectorAll('[data-product-variant-image]');

        // Match id with slides id's
        const slide = [...slides].find((slide) => {

          // Get variant id's attached to slide
          const slideVariants = parseJson(slide.dataset.productVariantImage);

          // Check if variant id match the slide variant id's
          if (slideVariants.includes(id)) {
            return slide;
          }

        });

        // return false if no slide found
        if (!slide) {
          return false;
        }

        // return matched slide index
        return getNodeIndex(slide)
      }


      /*
      * Create fancybox
      */
      fancybox() {

        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }

        Fancybox.bind("[data-fancybox]", {
          animated: false,
          showClass: false,
          mainClass: 'image-zoom',
          ...(document.querySelector('body').classList.contains('style--sg') && {
            Carousel: {
              Navigation: {
                nextTpl: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.2931 6.70711C12.9026 6.31658 12.9026 5.68342 13.2931 5.29289C13.6837 4.90237 14.3168 4.90237 14.7074 5.29289L20.7073 11.2929C21.0979 11.6834 21.0979 12.3166 20.7073 12.7071L14.7074 18.7071C14.3168 19.0976 13.6837 19.0976 13.2931 18.7071C12.9026 18.3166 12.9026 17.6834 13.2931 17.2929L17.586 13H4.01103C3.45265 13 3 12.5523 3 12C3 11.4477 3.45265 11 4.01103 11H17.586L13.2931 6.70711Z" fill="currentColor"/>
                </svg>`,
                prevTpl: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.7071 6.70711C11.0976 6.31658 11.0976 5.68342 10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289L3.29289 11.2929C2.90237 11.6834 2.90237 12.3166 3.29289 12.7071L9.29289 18.7071C9.68342 19.0976 10.3166 19.0976 10.7071 18.7071C11.0976 18.3166 11.0976 17.6834 10.7071 17.2929L6.4142 13H19.9892C20.5476 13 21.0002 12.5523 21.0002 12C21.0002 11.4477 20.5476 11 19.9892 11H6.41423L10.7071 6.70711Z" fill="currentColor"/>
                </svg>`,
              },
            },
          }),
        });

      }

    }

    window.ProductMediaSlider = ProductMediaSlider;

    customElements.define('product-media-slider', ProductMediaSlider);

  }

})();
